import React, { useEffect } from 'react';
import routes from "../routes.json";
import { Link } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import Badge from 'react-bootstrap/Badge';
import Button from 'react-bootstrap/Button';
import AppNav from '../templates-parts/nav';

function FormsList(props) {

    const [formsData, setFormsData] = React.useState();

    useEffect(() => {
        let _routes = routes;
        _routes.sort((a, b) => (b.conf > a.conf) ? 1 : -1)
        _routes = _routes.filter(route => route.conf !== 'boilerplate')
        setFormsData(_routes);
        getConfigs()
    }, []);


    const getConfigs = async () => {
        let _formsData = []
        for (const route of routes) {
            const config = await getConfig(route.conf)
            route.expiration = new Date(config.expiration).toLocaleDateString('fr') + ' ' + new Date(config.expiration).toLocaleTimeString('fr', { timeStyle: 'short', hour12: false });
            route.isExpired = (Date.now() > Date.parse(config.expiration)) ? true : false;
            _formsData.push(route)
        }
        setFormsData(_formsData)
    }



    // get config from json file
    const getConfig = async (confFile) => {
        const response = await fetch(`${process.env.PUBLIC_URL}/config/${confFile}.json`)
        const conf = await response.json();
        return conf;
    }



    return (
        <>
            <AppNav />

            <Container className='py-5'>
                <Table bordered>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Expiration</th>
                            <th></th>

                            {(!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ?
                                <th></th>
                                : null}
                        </tr>
                    </thead>
                    <tbody>
                        {formsData ? formsData.map(form => (
                            <tr key={'form-' + form.slug}>
                                <td>
                                    <Link target='_blank' key={form.slug} to={`/form/v2/${form.slug}`}>{form.conf}</Link>
                                </td>
                                {form.isExpired === undefined && <td> </td>}
                                {form.isExpired === true && <td><Badge bg="warning">Expired</Badge></td>}
                                {form.isExpired === false && <td><Badge bg="success">{form.expiration}</Badge></td>}

                                {/* {(!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ?
                                    <td>
                                        <Link target='_blank' key={form.slug} to={`/form/v2/up3zipkt/${form.slug}`}>
                                            <Button size='sm' variant="light">edit</Button></Link>
                                    </td>
                                    : null} */}
                                <td>
                                    <Link target='_blank' key={form.slug} to={`/form/v2/${form.slug}`}>
                                        <Button size='sm' variant="light">view</Button></Link>
                                </td>
                            </tr>
                        )) : null}
                    </tbody>
                </Table>
            </Container>
        </>
    );
}

export default FormsList;